/* eslint-disable*/

var checkEASubscription = function checkEASubscription(selectedLevel, exam_data) {
  var flag = false;
  for (var i = 0; i < exam_data.length; i++) {
    if (exam_data[i].exam_name === selectedLevel) {
      // console.log('2');
      if (exam_data[i].levels.length) {
        // console.log('3');
        for (var j = 0; j < exam_data[i].levels.length; j++) {
          // console.log('4');
          if (exam_data[i].levels[j].isActive) {
            // console.log('5');
            flag = true;
            break;
          }
        }
      } else {
        // console.log("6");
        flag = true;
      }
      break;
    } else {
      // console.log("7");
      if (exam_data[i].levels.length) {
        for (var j = 0; j < exam_data[i].levels.length; j++) {
          if (
            exam_data[i].levels[j].package_val === 'unlimited' &&
            exam_data[i].levels[j].package_id === 53
          ) {
            flag = true;
            break;
          }
          //  else if (
          //   exam_data[i].levels[j].isActive &&
          //   exam_data[i].levels[j].package_id === 35
          // ) {
          //   flag = true;
          //   break;
          // }
        }
      }
    }
  }
  return flag;
};

var checkEAVideosSubscription = function checkEAVideosSubscription(selectedLevel, exam_data) {
  console.log('I am here --------__> ', selectedLevel);
  console.log(exam_data, '<_-------------------------message 55');
  var flag = false;
  for (var i = 0; i < exam_data.length; i++) {
    if (exam_data[i].exam_name === selectedLevel) {
      if (exam_data[i].levels.length) {
        for (var j = 0; j < exam_data[i].levels.length; j++) {
          if (
            exam_data[i].levels[j].package_val === 'expensive' &&
            exam_data[i].levels[j].isActive &&
            exam_data[i].levels[j].videoStatus !== false
          ) {
            flag = true;
            // break;
          } else if (
            exam_data[i].levels[j].package_val === 'simple' &&
            exam_data[i].levels[j].isActive &&
            exam_data[i].levels[j].videoStatus !== false
          ) {
            flag = true;
            // break;/
          } else if (
            exam_data[i].levels[j].package_val === 'unlimited' &&
            exam_data[i].levels[j].isActive
          ) {
            flag = true;
            // break;
          }
        }
      } else {
        flag = true;
      }
      // break;
    } else {
      if (exam_data[i].levels.length) {
        for (var j = 0; j < exam_data[i].levels.length; j++) {
          if (
            exam_data[i].levels[j].package_val === 'unlimited' &&
            exam_data[i].levels[j].package_id === 53
          ) {
            flag = true;
            break;
          }
        }
      }
    }
  }
  return flag;
};

var checkEAQuestionSubscription = function checkEAQuestionSubscription(selectedLevel, exam_data) {
  var flag = false;
  for (var i = 0; i < exam_data.length; i++) {
    // console.log("1");

    if (exam_data[i].exam_name === selectedLevel) {
      // console.log("2");
      if (exam_data[i].levels.length) {
        // console.log("3");
        for (var j = 0; j < exam_data[i].levels.length; j++) {
          if (
            exam_data[i].levels[j].package_val === 'expensive' &&
            exam_data[i].levels[j].isActive
          ) {
            flag = true;
            break;
          } else if (
            exam_data[i].levels[j].package_val === 'simple' &&
            exam_data[i].levels[j].isActive &&
            exam_data[i].levels[j].noteStatus !== false
          ) {
            flag = true;
            break;
          } else if (
            exam_data[i].levels[j].package_val === 'unlimited' &&
            exam_data[i].levels[j].isActive
          ) {
            flag = true;
            break;
          }
        }
      } else {
        // console.log("6");
        flag = true;
      }
      // break;
    } else {
      // console.log("7");
      if (exam_data[i].levels.length) {
        for (var j = 0; j < exam_data[i].levels.length; j++) {
          if (
            exam_data[i].levels[j].package_val === 'unlimited' &&
            exam_data[i].levels[j].package_id === 53
          ) {
            flag = true;
            break;
          }
        }
      }
    }
  }

  return flag;
};

var checkEAQuizSubscription = function checkEAQuizSubscription(selectedLevel, exam_data) {
  var flag = false;
  for (var i = 0; i < exam_data.length; i++) {
    // console.log("1");

    if (exam_data[i].exam_name === selectedLevel) {
      // console.log("2");
      if (exam_data[i].levels.length) {
        // console.log("3");
        for (var j = 0; j < exam_data[i].levels.length; j++) {
          if (exam_data[i].levels[j].package_id === 51) {
            flag = false;
          }
          if (exam_data[i].levels[j].package_id === 52) {
            flag = true;
          }
          if (exam_data[i].levels[j].package_id === 53) {
            flag = true;
          }
        }
      }
      // break;
    }
  }

  return flag;
};
exports.checkEAQuizSubscription = checkEAQuizSubscription;
exports.checkEASubscription = checkEASubscription;
exports.checkEAQuestionSubscription = checkEAQuestionSubscription;
exports.checkEAVideosSubscription = checkEAVideosSubscription;



// WEBPACK FOOTER //
// ./src/views/RestAPI/EASubscription.js